import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'hybridCashPaymentEnabled',
  initialState: false,
  reducers: {
    setHybridCashPaymentEnabled(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setHybridCashPaymentEnabled } = slice.actions;

export default slice.reducer;
